import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';

// Ionic Modules
import { PreviewAnyFile } from '@awesome-cordova-plugins/preview-any-file/ngx';
import { Platform, LoadingController } from '@ionic/angular';

// Abstracts
import { NgDownloadService } from '../abstracts';

@Injectable()
export class DownloadService implements NgDownloadService {

    constructor(
      private platform: Platform,
      private http: HttpClient,
      private previewAnyFile: PreviewAnyFile,
      private loadingController: LoadingController) { }

    public async preview(url: string, fileName: string): Promise<any> {

        const loading = await this.loadingController.create({ translucent: true });
        loading.present();

        if (this.platform.is('capacitor')) {
            return this.previewAnyFile.preview(url)
                .finally(() => loading.dismiss());
        }
        else {
            this.http.get(url, { responseType: 'blob' })
                .toPromise()
                .then((blob) => {
                    saveAs(blob, fileName);
                })
                .finally(() => loading.dismiss());
        }
    }

}
